import { IApiError } from '@frontend/request';

import { ILoginResponse } from '@aqx-core/common/api/auth';
import {
  IMetatraderLoginMobileParams,
  IMetatraderLoginWebParams,
  metatraderLoginAPI
} from '@aqx-core/common/api/metatrader-login';
import { IAPIControllerCallbacks } from '@aqx-core/common/api/types';

class MetatraderLoginAPIController {
  public loginWebMT4Demo = async (
    params: IMetatraderLoginWebParams,
    callbacks: IAPIControllerCallbacks<ILoginResponse>
  ) => {
    try {
      const { result } = await metatraderLoginAPI.loginWebMT4Demo(params);
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };

  public loginMobileMT4Demo = async (
    params: IMetatraderLoginMobileParams,
    callbacks: IAPIControllerCallbacks<ILoginResponse>
  ) => {
    try {
      const { result } = await metatraderLoginAPI.loginMobileMT4Demo(params);
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };

  public loginWebMT4Live = async (
    params: IMetatraderLoginWebParams,
    callbacks: IAPIControllerCallbacks<ILoginResponse>
  ) => {
    try {
      const { result } = await metatraderLoginAPI.loginWebMT4Live(params);
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };

  public loginMobileMT4Live = async (
    params: IMetatraderLoginMobileParams,
    callbacks: IAPIControllerCallbacks<ILoginResponse>
  ) => {
    try {
      const { result } = await metatraderLoginAPI.loginMobileMT4Live(params);
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };

  public loginWebMT5Demo = async (
    params: IMetatraderLoginWebParams,
    callbacks: IAPIControllerCallbacks<ILoginResponse>
  ) => {
    try {
      const { result } = await metatraderLoginAPI.loginWebMT5Demo(params);
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };

  public loginMobileMT5Demo = async (
    params: IMetatraderLoginMobileParams,
    callbacks: IAPIControllerCallbacks<ILoginResponse>
  ) => {
    try {
      const { result } = await metatraderLoginAPI.loginMobileMT5Demo(params);
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };

  public loginWebMT5Live = async (
    params: IMetatraderLoginWebParams,
    callbacks: IAPIControllerCallbacks<ILoginResponse>
  ) => {
    try {
      const { result } = await metatraderLoginAPI.loginWebMT5Live(params);
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };

  public loginMobileMT5Live = async (
    params: IMetatraderLoginMobileParams,
    callbacks: IAPIControllerCallbacks<ILoginResponse>
  ) => {
    try {
      const { result } = await metatraderLoginAPI.loginMobileMT5Live(params);
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };
}

export const metatraderLoginAPIController = new MetatraderLoginAPIController();
